
export const setLocalData = (key, value) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(key, JSON.stringify(value));
  }
};


export const getLocalData = (key) => {
  if (typeof window !== "undefined") {
    const data = localStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  }
  return null;
};


export const removeLocalData = (key) => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(key);
  }
};


export const setLocalDataWithExpiry = (key, value, ttlMinutes = 20) => {
  if (typeof window !== "undefined") {
    const now = new Date().getTime();
    const item = {
      value,
      expiry: now + ttlMinutes * 60 * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }
};

export const getLocalDataWithExpiry = (key) => {
  if (typeof window !== "undefined") {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
      const item = JSON.parse(itemStr);
      const now = new Date().getTime();

      if (now > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      return item.value;
    } catch (err) {
      console.error("Error parsing localStorage data", err);
      return null;
    }
  }
  return null;
};

